import { useError } from "../Context/errorContext.js";
import { Alert, Snackbar, Box, Button, Typography } from "@mui/material";
import TimedSnackbar from "./timedSnackbar.js";

export default function GlobalErrorUI() {
  const { error, clearError, alerts, popAlert } = useError();
  return (
    <>
      {error && (
        <Box className="mainContainer" textAlign="center">
          <Typography color="error">
            {JSON.stringify(error, null, 4)}
          </Typography>
          <Button
            onClick={() => {
              clearError();
            }}
            href="/"
            variant="contained"
            color="primary"
          >
            Go Back to Projects
          </Button>
        </Box>
      )}

      {alerts.map((a, i) => (
        <TimedSnackbar key={a.id} a={a} i={i} onClose={() => popAlert(a.id)} />
      ))}
    </>
  );
}
